import EventInterface from "@app/Interface/EventInterface";
import * as React from 'react';

export default class EventHelper {
    /**
     * Builds a formatted date string for an event
     * 
     * @param event 
     * @returns string
     */
     static getEventDateString = (event: EventInterface): string => {
        const defaultOptions : Intl.DateTimeFormatOptions = {
            day: 'numeric',
            weekday: 'short',
            month: 'short',
            year: 'numeric',
        };
        if (event.eventAllDay) {
            return event.eventStartDate.toLocaleDateString('en-US', defaultOptions);
        }

        const startDate = event.eventStartDate.toLocaleDateString(
            'en-US', 
            {...defaultOptions, hour: 'numeric', minute: 'numeric', timeZoneName: 'short'}
        );
        const endDate = event.eventEndDate 
            ? event.eventEndDate.toLocaleDateString(
                'en-US',
                {...defaultOptions, hour: 'numeric', minute: 'numeric', timeZoneName: 'short'}
            ) 
            : null;
        if (endDate) {
            return `${startDate} – ${endDate}`;
        }

        return startDate;
    }

    /**
     * Builds a formatted date string for an event
     * 
     * @param event 
     * @returns React.ReactElement
     */
    static getDashboardEventDateMarkup = (event: EventInterface): React.ReactElement => {
        if (event.eventAllDay) {
            return <>{event.eventStartDate.toLocaleDateString('en-US', {day: 'numeric', month: 'short'})}</>;
        }

        return (
            <>
                {event.eventStartDate.toLocaleDateString('en-US', {day: 'numeric', month: 'short'})}
                <br />
                {event.eventStartDate.toLocaleTimeString('en-US', {hour: 'numeric', minute: 'numeric', timeZoneName: 'short'})}
            </>
        );
    }
}